const messages = {
  'en-US': {
    header: {
      STARTTitle: 'MA SRC SDK Testing Tool',
      checkout: 'SRC Checkout',
      newUser: 'New User Flow',
      returnUser: 'Returning User on New Device (unrecognized) ',
      callLogs: 'Call Logs',
      initialization: 'SDK Initialization',
      loader: 'SRC is in progress, Kindly go to SRC screen. Do not refresh or close this window.'
    },
    label: {
      copyright: 'Copyright ©',
      mastercardSRC: 'SRC Shop. All Rights Reserved',
      chooseEnv: 'Choose Environment:',
      srcClientId: 'SRC Client Id:',
      srcDpaId: 'SRC DPA Id:',
      srcTransactionId: 'SRC Transaction Id:',
      dpaLocale: 'DPA Locale:',
      srcSigningConsumerKey: 'SRC Signing Consumer key:',
      cryptoType: 'Type of cryptogram:',
      encryptedCard: 'Encrypted Card:',
      timeTaken: 'Log Time',
      request: 'Request',
      response: 'Response',
      clear: 'Clear',
      enterOtp: 'Enter the code ',
      sentTo: 'sent to',
      mastercard: 'Mastercard',
      note: 'Note:',
      otpMethodNote: 'First OTP is being sent on Phone. Please select from the below channels to resend OTP and call Initiate Identity Validation again.',
      checkout: 'Checkout',
      chooseCard: 'Choose a card',
      callPayloadApi: 'Call Payload API',
      pemKey: 'SRC Signing Private Key (In PEM Format)',
      pemKeyNote: 'openssl pkcs12 -in key.p12 -nodes -nocerts | openssl rsa -out key.key',
      callConfirmationApi: 'Call Confirmation API',
      encKey: 'SRC ENC Private Key (In PEM Format)'
    },
    methodCalls: {
      init: 'Init',
      isRecognized: 'isRecognized',
      idLookup: 'Identity Lookup',
      initiateIdentity: 'Initiate Identity Validation',
      completeIdentity: 'Complete Identity Validation',
      getSrcProfile: 'Get SRC Profile',
      addCard: 'Add Card',
      deleteCard: 'Delete Card'
    },
    errorMessages: {
      invalidSecureCode: 'Invalid secure code.',
      invalidExpiryDate: 'Invalid expiration date.',
      invalidExpiryYear: 'Invalid expiration year.',
      invalidCardNumber: 'Invalid payment card number. Please try again.',
      invalidCardType: 'Your payment card is not supported. Supported card brands: Mastercard, Visa, Amex, Discover.',
      invalidEmailAddress: 'Invalid email address.',
      emptyEmailAddress: 'Enter email address.',
      SRCI_ID_MISSING: 'The identifier for the SRC Initiator is missing.',
      DPA_ID_MISSING: 'The identifier for the DPA is missing.',
      ACCT_INACCESSIBLE: 'The account exists but is not currently accessible (e.g. is locked).',
      AUTH_INVALID: 'Invalid federated ID token.',
      CONSUMER_ID_MISSING: 'The consumer identity was required but not supplied.',
      FRAUD: 'The user account was locked or disabled.',
      ID_FORMAT_UNSUPPORTED: 'Unsupported Id format',
      OTP_SEND_FAILED: 'The OTP could not be sent to the recipient.',
      RETRIES_EXCEEDED: 'Too many verification attempts. Please continue as a guest.',
      SESSION_ID_INVALID: 'Invalid session ID.',
      CODE_INVALID: 'The supplied OTP value was invalid. Try again.',
      CODE_EXPIRED: 'The OTP is expired. Regenerate the OTP and try again.',
      CARD_MISSING: 'The encrypted card data is missing.',
      CARD_ADD_FAILED: 'Unable to add card.',
      CARD_SECURITY_CODE_MISSING: 'Card security must be supplied.',
      CARD_INVALID: 'Invalid card number.',
      CARD_DETAIL_INVALID: 'Invalid card details.',
      CARD_EXP_INVALID: 'Invalid card expiry date.',
      SERVICE_ERROR: 'Internal Server Error',
      INVALID_REQUEST: 'Invalid sdk request',
      AUTH_ERROR: 'Authentication Error',
      NOT_FOUND: 'Not found',
      INVALID_PARAMETER: 'Invalid code. Please try again.',
      UNKNOWN_ERROR: 'Unknown error',
      REQUEST_TIMEOUT: 'Request timeout',
      SERVER_ERROR: 'General server error',
      SRC_PROFILE_NOT_FOUND: 'SRC Profile is not found',
      ID_LOCKED: 'We could not authenticate your profile',
      NO_CARD_FOUND: 'No cards were found for this profile',
      AUTH_FAILED_ERROR: 'Continue as a guest, or try after 30 min to unlock your profile.',
      invalidOtp: 'Invalid OTP',
      CONSUMER_KEY_ERROR: 'Enter valid SRC Signing Consumer key.',
      PEM_KEY_ERROR: 'Enter valid SRC Signing Private Key.',
      ENC_KEY_ERROR: 'Enter valid SRC ENC Private Key.'
    }
  }
}
export default messages
